import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { AssetDto, GalleryDto } from '@nusign/picflow-backend-types';
import { SvgComponent } from '../../../shared/components/svg/svg.component';
import { TooltipDirective } from '../../../shared/directives/tooltip.directive';

@Component({
  selector: 'app-asset-page-meta',
  templateUrl: './asset-page-meta.component.html',
  styleUrls: ['./asset-page-meta.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TooltipDirective, SvgComponent],
})
export class AssetPageMetaComponent {
  readonly asset = input<AssetDto>(undefined);
  readonly gallery = input<GalleryDto>(undefined);
  readonly thumbnailBarOpen = input<boolean>(undefined);
  readonly center = input<boolean>(undefined);
  onThumbnailBarOpen = output<boolean>();
}
